"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BigsBoastfulBellowAbilityHandler = exports.BigsBoastfulBellowActorAbilityFactory = exports.BigsBoastfulBellowAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const core_1 = require("../../core/effects/core");
const enums_1 = require("../../core/enums");
const Duration_1 = require("../../core/Duration");
class BigsBoastfulBellowAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.BigsBoastfulBellow;
        this.__typeName = "BigsBoastfulBellow";
    }
}
exports.BigsBoastfulBellowAbilityArgs = BigsBoastfulBellowAbilityArgs;
let BigsBoastfulBellowActorAbilityFactory = class BigsBoastfulBellowActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("BigsBoastfulBellow", "AllAllies", 2);
    }
};
BigsBoastfulBellowActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("BigsBoastfulBellow")
], BigsBoastfulBellowActorAbilityFactory);
exports.BigsBoastfulBellowActorAbilityFactory = BigsBoastfulBellowActorAbilityFactory;
let BigsBoastfulBellowAbilityHandler = class BigsBoastfulBellowAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const invokerAgility = container.getAttributeScore(ability.invokerId, enums_1.AttributeType.Power);
        container.applyAbilityAnimation({
            sequence,
            abilityKey: ability.args.__typeName,
            fallback: "casting",
            animatedId: ability.invokerId,
            onAnimated: sequence => {
                container.selectLivingTargets(ability.invokerId, Target_1.Target.AllAllies)
                    .flatMap(actorId => container.getActor(actorId).companionIds)
                    .forEach(companionId => container.applyBuff({
                    sequence,
                    creatorId: ability.invokerId,
                    targetId: companionId,
                    hidden: true,
                    duration: Duration_1.Duration.Turns(2),
                    effect: new core_1.LinkedEffectsEffectArgs([
                        new core_1.MaxAttributeIncreaseEffectArgs(enums_1.AttributeType.CriticalDamageMultiplier, 100),
                        new core_1.MaxAttributeIncreaseEffectArgs(enums_1.AttributeType.Power, invokerAgility)
                    ], true)
                }));
            }
        });
    }
};
BigsBoastfulBellowAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.BigsBoastfulBellow)
], BigsBoastfulBellowAbilityHandler);
exports.BigsBoastfulBellowAbilityHandler = BigsBoastfulBellowAbilityHandler;
